import authApi from '@/api/auth'
import facebookHelper from '@/utils/facebookHelper'
import { checkByEmail } from '@/api/user.api'
import router from '@/router'

const state = {
  isAuthModalLoading: false,
  hasError: '',
  hasSuccess: '',
  authBox: {
    tab: 'sign-in',
    user: {
      exists: false,
      email: null,
      name: null,
      avatar: null
    }
  }
}

const mutations = {
  setLoading (state, newState) {
    state.isAuthModalLoading = newState
  },

  setError (state, error) {
    state.hasSuccess = ''
    state.hasError = error
  },

  setSuccess (state, success) {
    state.hasError = ''
    state.hasSuccess = success
  },

  resetModal (state) {
    state.hasSuccess = ''
    state.hasError = ''
  },

  setAuthBoxTab (state, tab) {
    state.hasError = ''
    state.authBox.tab = tab
  },

  setAuthBoxUser (state, user) {
    state.authBox.user = user
  }
}

const getters = {
  authBoxUser ({ authBox }, getters, rootState, rootGetters) {
    return rootGetters['user/isLogged']
      ? Object.assign({exists: true}, rootGetters['user/user'])
      : authBox.user
  },
  hasError ({ hasError }) {
    return hasError
  }
}

const actions = {
  async login ({ commit }, data) {
    let response
    try {
      response = await authApi.login(data)
    } catch (err) {
      commit('setError', err.data.message)

      commit('setLoading', false)

      return false
    }

    authApi.storeToken(response.data.data.token)
    commit('user/setUser', response.data.data.user, { root: true })
    commit('user/setToken', response.data.data.token, { root: true })
    commit('user/setLogged', true, { root: true })

    return true
  },

  async requestResetPassword ({ commit }, email) {
    commit('setLoading', true)

    try {
      const response = await authApi.requestResetPassword(email)

      commit('setSuccess', response.data.message)

      commit('setLoading', false)
    } catch (err) {
      commit('setError', err.data.message)

      commit('setLoading', false)

      throw err.data.message
    }
  },

  async changePasswordByReset (context, data) {
    return await authApi.changePasswordByReset(data)
  },

  async googleLogin ({ commit }) {
      commit('setLoading', true)

      try {
        const gapi = await this._vm.$getGapiClient()
        const user = await gapi.auth2.getAuthInstance().signIn()
        const token = user.getAuthResponse().access_token

        const response = await authApi.loginGoogle(token)

        authApi.storeToken(response.data.data.token)
        commit('user/setUser', response.data.data.user, { root: true })
        commit('user/setToken', response.data.data.token, { root: true })
        commit('user/setLogged', true, { root: true })

        window.location.href = '/'
      } catch (err) {
        commit('setError', 'Não é possível logar-se com o Google utilizando uma aba anônima.')
        commit('setLoading', false)
        throw err
      }
  },
  async facebookLogin ({ commit }) {
    commit('setLoading', true)

    await facebookHelper.loadFacebookSDK()
    await facebookHelper.initFacebook()
    const facebookResponse = await facebookHelper.login()

    if (facebookResponse.status == 'connected') {
      const token = facebookResponse.authResponse.accessToken
      const loginResponse = await authApi.loginFacebook(token)

      authApi.storeToken(loginResponse.data.data.token)
      commit('user/setUser', loginResponse.data.data.user, { root: true })
      commit('user/setToken', loginResponse.data.data.token, { root: true })
      commit('user/setLogged', true, { root: true })

      window.location.href = '/'
    }

    commit('setLoading', false)
    return false;
  },

  async register (context, data) {
    const response = await authApi.register(data)

    authApi.storeToken(response.data.data.token)

    window.location.href = '/confirmar-dados'

    return response
  },

  async logout ({ commit }) {
    commit('app/setLoading', true, { root: true })

    // await authApi.logout()
    authApi.removeToken()

    commit('user/setToken', '', { root: true })
    commit('user/setUser', {}, { root: true })
    commit('user/setLogged', false, { root: true })

    window.location.href = '/'
  },

  async authBoxCheckEmail ({ state, commit }, email) {
    const user = await checkByEmail(email)

    if (user) {
      state.authBox.user = user
      state.authBox.user.exists = true
    } else {
      state.authBox.user.avatar = '/img/no-avatar.jpg'
    }

    commit('setAuthBoxTab', 'sign-up-email')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
